import React, { useState } from 'react'; // eslint-disable-line project-structure/folder-structure
import {
  arrayOf,
  bool,
  oneOfType,
  string,
  node,
  func,
  shape,
} from 'prop-types';
import { connect } from 'react-redux';
import { Gutter, Suspense } from '@axiom/ui';

import { Header } from '../components/Header/Header';
import { Banner } from '../components/Banner/Banner';
import Sidebar from '../components/Sidebar/Sidebar';
import AppErrors from '../components/AppErrors/AppErrors';
import LoadingTreatment from '../components/LoadingTreatment/LoadingTreatment';
import { hasInitialDataSelector } from '../redux/selectors/app';
import { SideDrawer } from '../components/SideDrawer/SideDrawer';

import { ErrorBoundaryLayout } from './ErrorBoundaryLayout/ErrorBoundaryLayout';
import { AppWrapper, InnerPage, StyledSection, WorkArea } from './styles';

const DefaultComponent = ({
  aiSearchContent,
  apiErrors,
  children,
  sidebarContent,
  user,
  hasInitialData,
  hideSideDrawer,
  sideBarActive,
  sideDrawerActive,
  simple,
  name,
}) => {
  const [expandedSideDrawer, setExpandedSideDrawer] = useState(false);
  const rightSideGutter = !hideSideDrawer || sidebarContent ? '72px' : '16px';
  const closeSideDrawer = () => {
    setExpandedSideDrawer(false);
  };

  if (hasInitialData && user) {
    return (
      <AppWrapper data-test={name}>
        <AppErrors />
        <Header closeSideDrawer={closeSideDrawer} user={user} />
        <Suspense fallback={null}>
          <Banner />
        </Suspense>
        {simple ? (
          children
        ) : (
          <InnerPage>
            <WorkArea>
              <StyledSection>{children}</StyledSection>
            </WorkArea>

            <Gutter right={rightSideGutter} />
            {sidebarContent ? (
              <Sidebar
                sideBarActive={sideBarActive}
                sideDrawerActive={sideDrawerActive}
                aiSearchContent={aiSearchContent}
              >
                {sidebarContent}
              </Sidebar>
            ) : null}
            {!hideSideDrawer && (
              <SideDrawer
                expanded={expandedSideDrawer}
                setExpanded={setExpandedSideDrawer}
              />
            )}
          </InnerPage>
        )}
      </AppWrapper>
    );
  }

  return apiErrors.some(error => !!error) ? (
    <ErrorBoundaryLayout />
  ) : (
    <LoadingTreatment maxLoadMilliseconds={30000} />
  );
};

DefaultComponent.defaultProps = {
  aiSearchContent: null,
  apiErrors: [],
  hasInitialData: false,
  sidebarContent: null,
  children: null,
  hideSideDrawer: false,
  sideBarActive: true,
  sideDrawerActive: false,
  user: null,
  simple: false,
  name: undefined,
};

DefaultComponent.propTypes = {
  aiSearchContent: node,
  apiErrors: arrayOf(shape({})),
  children: oneOfType([string, node, func]),
  hasInitialData: bool,
  hideSideDrawer: bool,
  name: string,
  sideBarActive: bool,
  sidebarContent: node,
  sideDrawerActive: bool,
  simple: bool,
  user: shape({
    activeDirectorySecurityGroup: string,
  }),
};
// HMR does not work well with composition function, need to split these
// into their own variables so they can be replaced by updates.
const ConnectHOC = connect(hasInitialDataSelector);
export default ConnectHOC(DefaultComponent);
